module.exports = __webpack_public_path__ + "img/green-round-check.4e14c2e1.svg";